<template>
    <div
        class="ppv2-flex ppv2-flex-wrap ppv2-w-full ppv2-step-wrapper md:ppv2-gap-[3.125vw]"
        :style="{ paddingLeft: normalizeSize(55) }"
    >
        <!-- Form Section -->
        <div class="form-section duration-section">
            <HeaderStep :step="step" :sizes="sizes" />

            <SelectableList
                :label="$t('experience.step4.reservationMode.Question')"
                v-model="pricing.is_ticket"
                :options="options_tickets"
                class="ppv2-mb-[20px]"
                @input="clearError('is_ticket')"
            />

            <div
                class="gestion_creneau ppv2-flex ppv2-flex-wrap ppv2-items-center ppv2-justify-between ppv2-border ppv2-border-[#545595] ppv2-rounded-[12px] ppv2-text-black ppv2-mb-2 ppv2-px-3 ppv2-min-h-[54px]"
            >
                <label
                    class="ppv2-truncate"
                    :style="{
                        fontSize: normalizeFontSize(12),
                        width: 'calc(100% - ' + normalizeSize(115, true) + ')',
                        minWidth: 'max-content',
                    }"
                >
                    {{ $t('treatment.step3.utilisations_label') }}
                </label>

                <div :style="{ width: normalizeSize(100, true) }">
                    <CustomInput
                        v-model="pricing.prestations_qty"
                        :required="true"
                        type="number"
                        :min="1"
                        @input="clearError('prestations_qty')"
                        :state="getState('prestations_qty')"
                        @focus="activeField = 'prestations'"
                        @blur="activeField = null"
                        classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                        classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                        :customSizeLabel="10"
                        customClassLabel="poppinsMedium"
                    />
                </div>
            </div>

            <div
                v-if="!isOn"
                class="ppv2-relative"
                :style="{ marginTop: normalizeSizeVertical(27, true), marginBottom: normalizeSizeVertical(20) }"
            >
                <div class="ppv2-mx-[10px] ppv2-px-1 ppv2-bg-white dark:ppv2-bg-dark">
                    <BaseSwitch
                        v-model="isOn"
                        label="Limiter par période"
                        @focus="activeField = 'parameters'"
                        @blur="activeField = null"
                    />
                </div>
            </div>
            <DashedCard
                v-else
                :marginTop="37"
                :marginBottom="27"
                :custom-style="{ padding: normalizeSize(24, true), justifyContent: 'center' }"
            >
                <template #title>
                    <BaseSwitch
                        v-model="isOn"
                        label="Limiter par période"
                        @focus="activeField = 'parameters'"
                        @blur="activeField = null"
                    />
                </template>
                <template #content>
                    <div
                        class="gestion_creneau ppv2-flex ppv2-flex-wrap ppv2-items-center ppv2-border ppv2-border-[#545595] ppv2-rounded-[12px] ppv2-text-black ppv2-mb-2 ppv2-min-h-[54px] ppv2-justify-between"
                    >
                        <label
                            class="ppv2-text-black poppinsRegular"
                            :style="{
                                fontSize: normalizeFontSize(14),
                                width: 'calc(100% - ' + normalizeSize(115, true) + ')',
                                minWidth: 'max-content',
                            }"
                        >
                            {{ $t('treatment.step3.limit_usage_period') }}
                        </label>

                        <div class="ppv2-mr-3" :style="{ width: normalizeSize(100, true) }">
                            <BaseSelect
                                v-model="parameters.interval_hours_type"
                                :options="intervalOptions"
                                optionLabel="label"
                                optionValue="value"
                                compact
                                :placeholder="$t('common.select')"
                                @input="clearError('interval_hours_type')"
                                :error="errors.interval_hours_type"
                                @open="activeField = 'parameters'"
                                @close="activeField = null"
                                class="transparent-select"
                                class-added="!ppv2-h-[30px] mb-2 !ppv2-rounded-lg !ppv2-mb-2"
                                :floatingLabel="true"
                                :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                            />
                        </div>

                        <BaseSwitch
                            v-model="parameters.toggle_peak_hours"
                            :label="$t('treatment.step3.limit_total_peak')"
                            :custom-style="{ width: 'calc(100% - ' + normalizeSize(115, true) + ')' }"
                            @input="clearError('toggle_peak_hours')"
                            :error="errors.toggle_peak_hours"
                            @focus="activeField = 'parameters'"
                            @blur="activeField = null"
                            customClass="mb-2"
                        />
                        <div v-if="parameters.toggle_peak_hours" class="ppv2-mr-3" :style="{ width: normalizeSize(100, true) }">
                            <CustomInput
                                v-model="parameters.total_peak_hours"
                                type="number"
                                :min="0"
                                @input="clearError('total_peak_hours')"
                                :state="getState('total_peak_hours')"
                                @focus="activeField = 'parameters'"
                                @blur="activeField = null"
                                classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                                classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                :customSizeLabel="10"
                                customClassLabel="poppinsMedium"
                                :floatingLabel="true"
                                :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                            />
                        </div>

                        <BaseSwitch
                            v-model="parameters.toggle_off_peak_hours"
                            :label="$t('treatment.step3.limit_total_off_peak')"
                            :custom-style="{ width: 'calc(100% - ' + normalizeSize(115, true) + ')' }"
                            @input="clearError('toggle_off_peak_hours')"
                            :error="errors.toggle_off_peak_hours"
                            @focus="activeField = 'parameters'"
                            @blur="activeField = null"
                            customClass="mb-2"
                        />
                        <div
                            v-if="parameters.toggle_off_peak_hours"
                            class="ppv2-mr-3"
                            :style="{ width: normalizeSize(100, true) }"
                        >
                            <CustomInput
                                v-model="parameters.total_off_peak_hours"
                                type="number"
                                :min="0"
                                @input="clearError('total_off_peak_hours')"
                                :state="getState('total_off_peak_hours')"
                                @focus="activeField = 'parameters'"
                                @blur="activeField = null"
                                classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                                classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                :customSizeLabel="10"
                                customClassLabel="poppinsMedium"
                                :floatingLabel="true"
                                :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                            />
                        </div>

                        <BaseSwitch
                            v-model="parameters.toggle_max_off_peak_hours"
                            :label="$t('treatment.step3.limit_max_off_peak_per')"
                            :custom-style="{ width: 'calc(100% - ' + normalizeSize(115, true) + ')' }"
                            @input="clearError('toggle_max_off_peak_hours')"
                            :error="errors.toggle_max_off_peak_hours"
                            @focus="activeField = 'parameters'"
                            @blur="activeField = null"
                            customClass="mb-2"
                        />

                        <div
                            v-if="parameters.toggle_max_off_peak_hours"
                            class="ppv2-mr-3"
                            :style="{ width: normalizeSize(100, true) }"
                        >
                            <CustomInput
                                v-model="parameters.nb_off_peak_hours_per"
                                type="number"
                                :min="0"
                                @input="clearError('nb_off_peak_hours_per')"
                                :state="getState('nb_off_peak_hours_per')"
                                @focus="activeField = 'parameters'"
                                @blur="activeField = null"
                                classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                                classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                :customSizeLabel="10"
                                customClassLabel="poppinsMedium"
                                :floatingLabel="true"
                                :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                            />
                        </div>

                        <BaseSwitch
                            v-model="parameters.toggle_max_peak_hours"
                            :label="$t('treatment.step3.limit_max_peak_per')"
                            :custom-style="{ width: 'calc(100% - ' + normalizeSize(115, true) + ')' }"
                            @input="clearError('toggle_max_peak_hours')"
                            :error="errors.toggle_max_peak_hours"
                            @focus="activeField = 'parameters'"
                            @blur="activeField = null"
                            customClass="mb-2"
                        />
                        <div
                            v-if="parameters.toggle_max_peak_hours"
                            class="ppv2-mr-3"
                            :style="{ width: normalizeSize(100, true) }"
                        >
                            <CustomInput
                                v-model="parameters.nb_peak_hours_per"
                                type="number"
                                :min="0"
                                @input="clearError('nb_peak_hours_per')"
                                :state="getState('nb_peak_hours_per')"
                                @focus="activeField = 'parameters'"
                                @blur="activeField = null"
                                classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                                classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                :customSizeLabel="10"
                                customClassLabel="poppinsMedium"
                                :floatingLabel="true"
                                :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                            />
                        </div>

                        <BaseSwitch
                            v-model="parameters.allow_peak_for_off_peak"
                            :label="$t('treatment.step3.allow_peak_for_off_peak')"
                            :custom-style="{ width: 'calc(100% - ' + normalizeSize(115, true) + ')' }"
                            @input="clearError('allow_peak_for_off_peak')"
                            :error="errors.allow_peak_for_off_peak"
                            @focus="activeField = 'parameters'"
                            @blur="activeField = null"
                            customClass="mb-2"
                        />
                    </div>
                </template>
            </DashedCard>

            <!-- Empty State -->
            <div v-if="treatmentPrestations.length === 0" class="empty-state ppv2-mb-6">
                <DashedCard
                    :marginTop="37"
                    :marginBottom="37"
                    min-height="150px"
                    :custom-style="{ padding: normalizeSize(24, true) }"
                >
                    <template #content>
                        <div
                            class="ppv2-flex-1 ppv2-flex ppv2-flex-col ppv2-items-center ppv2-justify-center"
                            :style="{ gap: normalizeSizeVertical(14, true) }"
                        >
                            <p class="!ppv2-mb-0 ppv2-text-black" style="font-size: 12px">
                                {{ $t('treatment.step3.empty_state') }}
                            </p>
                            <BaseButton type="button" variant="secondary" :customFontSize="12" @click="addNewItem">
                                <span class="ppv2-flex ppv2-items-center ppv2-gap-2">
                                    <Plus :size="12" />
                                    {{ $t('treatment.step3.add_activity') }}
                                </span>
                            </BaseButton>
                        </div>
                    </template>
                </DashedCard>
            </div>

            <!-- Prestations List -->
            <div v-else class="ppv2-mb-6">
                <DashedCard
                    :title="$t('treatment.step3.select_activities_title')"
                    :title-size="15"
                    :marginTop="37"
                    :marginBottom="37"
                    min-height="150px"
                    :custom-style="{ padding: normalizeSize(24, true) }"
                >
                    <template #content>
                        <div class="ppv2-flex-1 ppv2-flex ppv2-flex-col ppv2-w-full">
                            <div class="ppv2-space-y-4 ppv2-mb-6 ppv2-w-full">
                                <div
                                    v-for="(item, index) in treatmentPrestations"
                                    :key="index"
                                    class="prestation-item-container ppv2-flex ppv2-items-center ppv2-relative"
                                    draggable="true"
                                    @dragstart="onDragStart($event, index)"
                                    @dragover="onDragOver($event)"
                                    @drop="onDrop($event, index)"
                                    @dragenter="onDragEnter($event)"
                                    @dragleave="onDragLeave($event)"
                                    @dragend="onDragEnd($event)"
                                >
                                    <GripVertical
                                        :size="16"
                                        color="#9D96A8"
                                        class="ppv2-cursor-grab ppv2-absolute ppv2-left-[-17px]"
                                    />
                                    <div class="prestation-item ppv2-border ppv2-rounded-lg ppv2-p-4 ppv2-flex-1">
                                        <div
                                            class="ppv2-flex ppv2-flex-wrap ppv2-items-start ppv2-w-full"
                                            :style="{ gap: normalizeSize(16, true) }"
                                        >
                                            <!-- Prestation Selection -->
                                            <div class="ppv2-flex-1">
                                                <BaseSelect
                                                    :label="$t('treatment.step3.activity_label') + ' ' + (index + 1)"
                                                    v-model="item.selectedPrestation"
                                                    :options="getAvailablePrestations(index)"
                                                    optionLabel="name"
                                                    :reduce="(opt) => opt"
                                                    :placeholder="$t('treatment.step2.placeholder_select')"
                                                    :searchable="true"
                                                    :customSizeLabel="13"
                                                    @input="
                                                        onPrestationChange(index, $event)
                                                        clearError('prestations')
                                                    "
                                                    :error="errors.prestations"
                                                    @open="activeField = 'prestations'"
                                                    @close="activeField = null"
                                                    class="transparent-select ppv2-w-full"
                                                    class-added="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                                                    :floatingLabel="true"
                                                    :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                                                />
                                            </div>

                                            <!-- Duration Selection -->
                                            <div class="ppv2-w-40">
                                                <BaseSelect
                                                    label="Durée"
                                                    :searchable="false"
                                                    :customSizeLabel="13"
                                                    v-model="item.selectedDuration"
                                                    :options="getAvailableDurations(item.selectedPrestation)"
                                                    :option-label="(option) => formatDuration(option)"
                                                    :reduce="(opt) => opt"
                                                    :placeholder="$t('treatment.step3.duration_label')"
                                                    :disabled="!item.selectedPrestation"
                                                    class="transparent-select"
                                                    @input="
                                                        onDurationChange(index, $event)
                                                        clearError('prestations')
                                                    "
                                                    :error="errors.prestations"
                                                    @open="activeField = 'prestations'"
                                                    @close="activeField = null"
                                                    class-added="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                                                    :floatingLabel="true"
                                                    :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                                                />
                                            </div>

                                            <!-- Quantity -->
                                            <div class="ppv2-w-24">
                                                <CustomInput
                                                    label="Quantité"
                                                    v-model="item.quantity"
                                                    type="number"
                                                    :min="1"
                                                    classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                                    :customSizeLabel="13"
                                                    @input="
                                                        onQuantityChange(index, $event)
                                                        clearError('prestations')
                                                    "
                                                    @focus="activeField = 'prestations'"
                                                    @blur="activeField = null"
                                                    :state="getState('prestations')"
                                                    classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] mb-2 !ppv2-rounded-lg "
                                                    :floatingLabel="true"
                                                    :floatingLabelBg="theme.mode === 'dark' ? '#131733' : '#fff'"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Remove Button -->
                                    <div
                                        class="ppv2-bg-white ppv2-bg-opacity-5 border_btns ppv2-opacity-75 ppv2-text-black ppv2-text-opacity-90 d-flex align-items-center justify-center px-2"
                                        :style="{ width: '26px', marginLeft: normalizeSize(14), height: '26px' }"
                                    >
                                        <button
                                            type="button"
                                            @click="removeItem(index)"
                                            class="transparent-btn ppv2-text-black ppv2-flex ppv2-items-center ppv2-justify-center"
                                            title="Supprimer"
                                        >
                                            <Minus :size="15" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Add Item Button -->
                            <div
                                v-if="treatmentPrestations.length < maxItems"
                                class="ppv2-flex ppv2-justify-center"
                                :style="{ marginBottom: normalizeSizeVertical(10) }"
                            >
                                <BaseButton type="button" variant="secondary" :customFontSize="12" @click="addNewItem">
                                    <span class="ppv2-flex ppv2-items-center ppv2-gap-2">
                                        <Plus :size="12" />
                                        {{ $t('treatment.step3.add_activity') }}
                                    </span>
                                </BaseButton>
                            </div>
                        </div>
                    </template>
                </DashedCard>
            </div>

            <!-- Validation Error -->
            <div v-if="errors.prestations" class="error-text ppv2-mb-4">
                {{ errors.prestations }}
            </div>

            <!-- Navigation Buttons -->
            <div class="form-actions" :class="{ '!ppv2-justify-end': complited }">
                <BackButton v-show="!complited" type="button" @click="$emit('previous-step')" />
                <BaseButton id="submit" type="button" @click="submitForm" variant="primary" :loading="loading">
                    {{ complited ? $t('common.save') : $t('experience.next') }}
                </BaseButton>
            </div>
        </div>

        <!-- Preview Panel -->
        <PreviewTreatment :active-field="activeField" :step="step" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeSizeVertical from '../../../../utils/normalizeSizeVertical'
import HeaderStep from './HeaderStep.vue'
import PreviewTreatment from './PreviewTreatment.vue'
import BaseButton from '../../../Shared/BaseButton.vue'
import BackButton from '../../../Shared/BackButton.vue'
import DashedCard from '../../../Shared/DashedCard.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import CustomInput from '../../../Inputs/CustomInput.vue'
import SelectableList from '../../../Shared/SelectableList.vue'
import { Plus, Minus, GripVertical } from 'lucide-vue'
import normalizeFontSize from '../../../../utils/normalizeFontSize'

export default {
    name: 'TreatmentStep3',
    components: {
        HeaderStep,
        PreviewTreatment,
        BaseButton,
        BackButton,
        DashedCard,
        BaseSwitch,
        BaseSelect,
        CustomInput,
        SelectableList,
        Plus,
        Minus,
        GripVertical,
    },
    props: {
        step: { type: Object, required: true },
        sizes: { type: Object, required: true },
        id: { type: [Number, String], default: null },
        complited: { type: [Boolean], default: false },
    },
    data() {
        return {
            activeField: null,
            errors: {},
            isOn: true,
            maxItems: 20,
            draggedIndex: null,
            initialDataString: null,
        }
    },
    computed: {
        ...mapGetters('treatment', [
            'parameters',
            'pricing',
            'isEditMode',
            'treatmentPrestations',
            'availablePrestations',
            'loading',
        ]),
        intervalOptions() {
            return [
                { label: this.$t('treatment.step3.options.week'), value: 'week' },
                { label: this.$t('treatment.step3.options.month'), value: 'month' },
            ]
        },
        options_tickets() {
            return [
                {
                    label: this.$t('treatment.step3.options.participant_label'),
                    value: true,
                    subtitle: this.$t('treatment.step3.options.participant_subtitle'),
                },
                {
                    label: this.$t('treatment.step3.options.space_label'),
                    value: false,
                    subtitle: this.$t('treatment.step3.options.space_subtitle'),
                },
            ]
        },
        parameters: {
            get() {
                return this.$store.getters['treatment/parameters']
            },
            set(value) {
                this.$store.dispatch('treatment/setParameters', value)
            },
        },
        pricing: {
            get() {
                return this.$store.getters['treatment/pricing']
            },
            set(value) {
                this.$store.dispatch('treatment/setPricing', value)
            },
        },
        treatmentPrestations: {
            get() {
                return this.$store.getters['treatment/treatmentPrestations']
            },
            set(value) {
                this.$store.dispatch('treatment/setTreatmentPrestations', value)
            },
        },
        hoursOptions() {
            return Array.from({ length: 100 }, (_, i) => ({
                label: `${i + 1}`,
                value: i + 1,
            }))
        },
    },
    mounted() {
        // Add initial item if empty
        if (this.treatmentPrestations.length === 0) {
            this.addNewItem()
        }
        this.initialDataString = this.getFormDataString()
    },
    watch: {
        'parameters.toggle_peak_hours'(val) {
            if (!val) {
                this.setParameters({
                    ...this.parameters,
                    total_peak_hours: null,
                })
            }
        },
        'parameters.toggle_off_peak_hours'(val) {
            if (!val) {
                this.setParameters({
                    ...this.parameters,
                    total_off_peak_hours: null,
                })
            }
        },
        'parameters.toggle_max_peak_hours'(val) {
            if (!val) {
                this.setParameters({
                    ...this.parameters,
                    nb_peak_hours_per: null,
                })
            }
        },
        'parameters.toggle_max_off_peak_hours'(val) {
            if (!val) {
                this.setParameters({
                    ...this.parameters,
                    nb_off_peak_hours_per: null,
                })
            }
        },
    },
    methods: {
        normalizeFontSize,
        ...mapActions('treatment', [
            'setParameters',
            'setPricing',
            'saveTreatment',
            'addTreatmentPrestation',
            'updateTreatmentPrestation',
            'removeTreatmentPrestation',
            'setTreatmentPrestations',
        ]),
        normalizeSize,
        normalizeSizeVertical,

        clearError(field) {
            if (this.errors && this.errors[field]) {
                const newErrors = { ...this.errors }
                delete newErrors[field]
                this.errors = newErrors
            }
        },

        getState(field) {
            if (this.errors && this.errors[field]) return 'error'
            if (this.pricing && this.pricing[field]) return 'valid'
            if (this.parameters && this.parameters[field]) return 'valid'
            if (field === 'prestations' && this.treatmentPrestations.length > 0) return 'valid'
            return 'default'
        },

        getAvailablePrestations(currentIndex) {
            return this.$store.getters['treatment/getAvailablePrestations'](currentIndex)
        },

        getAvailableDurations(prestation) {
            if (!prestation) return []
            return prestation.prices_by_times || prestation.pricesByTimes || prestation.durations || []
        },

        formatDuration(option) {
            if (!option) return ''
            return `${option.duration} min`
        },

        addNewItem() {
            this.addTreatmentPrestation({
                selectedPrestation: null,
                selectedDuration: null,
                quantity: 1,
            })
        },

        removeItem(index) {
            this.removeTreatmentPrestation(index)
        },

        onPrestationChange(index, prestation) {
            this.updateTreatmentPrestation({
                index,
                data: {
                    selectedPrestation: prestation,
                    selectedDuration: null,
                },
            })
        },

        onDurationChange(index, duration) {
            this.updateTreatmentPrestation({
                index,
                data: { selectedDuration: duration },
            })
        },

        onQuantityChange(index, quantity) {
            this.updateTreatmentPrestation({
                index,
                data: { quantity: parseInt(quantity) || 1 },
            })
        },

        validateForm() {
            this.errors = {}

            if (this.treatmentPrestations.length === 0) {
                this.errors.prestations = this.$t('treatment.step3.validation.add_one_activity')
                return false
            }

            const hasIncomplete = this.treatmentPrestations.some((item) => !item.selectedPrestation || !item.selectedDuration)

            if (hasIncomplete) {
                this.errors.prestations = this.$t('treatment.step3.validation.complete_all_activities')
                return false
            }

            return true
        },

        async submitForm() {
            // Local validation
            if (!this.validateForm()) {
                return
            }

            // Save to API with error handling
            try {
                await this.saveTreatment()

                this.initialDataString = this.getFormDataString()
                this.$toast.success(this.$t('treatment.notifications.success_update'))

                if (!this.complited) {
                    this.$emit('next-step')
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)

                // Display field-specific validation errors if present
                if (error.response?.data?.errors) {
                    this.errors = { ...this.errors, ...error.response.data.errors }
                }
            }
        },

        async saveStep(redirect = false) {
            try {
                await this.saveTreatment()
                this.initialDataString = this.getFormDataString()
                if (redirect) {
                    const baseUrl = `${window.location.protocol}//${window.location.host}`
                    window.location.href = `${baseUrl}/back-office/v3/experience`
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                console.error('Error saving treatment:', error)
            }
        },

        getFormDataString() {
            return JSON.stringify({
                is_ticket: this.pricing.is_ticket,
                prestations_qty: this.pricing.prestations_qty,
                parameters: this.parameters,
                treatmentPrestations: this.treatmentPrestations,
            })
        },

        hasChanges() {
            if (!this.initialDataString) return false
            return this.initialDataString !== this.getFormDataString()
        },

        revertChanges() {
            if (!this.initialDataString) return
            const data = JSON.parse(this.initialDataString)
            this.$store.dispatch('treatment/setPricing', {
                is_ticket: data.is_ticket,
                prestations_qty: data.prestations_qty,
            })
            this.$store.dispatch('treatment/setParameters', data.parameters)
            this.$store.dispatch('treatment/setTreatmentPrestations', data.treatmentPrestations)
        },

        onDragStart(evt, index) {
            evt.dataTransfer.setData('text/plain', index)
            evt.dataTransfer.effectAllowed = 'move'
            this.draggedIndex = index
        },

        onDragOver(evt) {
            evt.preventDefault()
            evt.dataTransfer.dropEffect = 'move'
        },

        onDrop(evt, targetIndex) {
            evt.preventDefault()
            const fromIndex = this.draggedIndex
            const toIndex = targetIndex

            const container = evt.currentTarget.closest('.prestation-item-container')
            if (container) container.style.backgroundColor = ''

            if (fromIndex !== toIndex && fromIndex !== null) {
                const items = [...this.treatmentPrestations]
                const item = items.splice(fromIndex, 1)[0]
                items.splice(toIndex, 0, item)
                this.treatmentPrestations = items
            }
            this.draggedIndex = null
        },

        onDragEnter(evt) {
            const container = evt.currentTarget.closest('.prestation-item-container')
            if (container) container.style.backgroundColor = 'rgba(255, 255, 255, 0.05)'
        },

        onDragLeave(evt) {
            const container = evt.currentTarget.closest('.prestation-item-container')
            if (container && !container.contains(evt.relatedTarget)) {
                container.style.backgroundColor = ''
            }
        },

        onDragEnd(evt) {
            this.draggedIndex = null
            const allItems = document.querySelectorAll('.prestation-item-container')
            allItems.forEach((item) => {
                item.style.backgroundColor = ''
            })
        },
    },
}
</script>

<style scoped>
.form-section {
    flex: 1;
}

.form-actions {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-top: 40px;
}

.gestion_creneau {
    background-color: #1a1f370d;
    padding: 10px 12px;
}

.dark .gestion_creneau {
    background-color: rgba(255, 255, 255, 0.05);
}

.prestation-item {
    border-color: rgba(0, 0, 0, 0.1);
}

.dark .prestation-item {
    border-color: rgba(255, 255, 255, 0.1);
}

.border_btns {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

.dark .border_btns {
    border-color: rgba(255, 255, 255, 0.1);
}

.transparent-btn {
    background: transparent;
    border: none;
    cursor: pointer;
}
</style>
